import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    ActivatedRouteSnapshot
} from '@angular/router';

import { ApiAnnuaireService } from '../../../annuaire/services/api-annuaire.service';

@Injectable()
export class ListingZaEntreprisesResolve implements Resolve<any> {
    constructor(private _apiService: ApiAnnuaireService, private router: Router) { }

    resolve(route: ActivatedRouteSnapshot): Promise<any> | boolean {
        let id = route.params['id'];

        return this._apiService.getEntreprisesByZone(id, 1).then(results => {
            console.log('resolver listing za :', results);
            if (results) {
                return {
                    'entreprises' : results,
                    'idZone' : id
                };

            } else {
                return null;
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/zone-activite/listing/resolve/listing.resolve.service.ts